import React, { useEffect, useState } from "react";
import { Container, Modal, Button, Form, Col, ListGroup } from "react-bootstrap";
import { connect } from "react-redux";
import { baseURL, headers } from "../../../../../global/api";
import { DeleteCRMCustomer, UpdateCRMCustomerAPi, SendCustomerEmailApi } from "./CustomerActionCRM";
import { setHeading } from "../../../accounts/account.actions";
import MaterialTable from "material-table";
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import Swal from "sweetalert";
import CommentIcon from '@mui/icons-material/Comment';
const tableRef = React.createRef()


const ViewCustomerCRM = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [emailMessage, setEmailMessage] = useState("");
  const [emailTitle, setEmailTitle] = useState("");
  const [attachment, setAttachment] = useState(null);

  const handleEmailClick = (rowData) => {
    setSelectedCustomer(rowData);
    setShowModal(true);
  };

  const handleCommentClick = (rowData) => {
    setSelectedCustomer(rowData);
    setShowCommentModal(true);
  };

  const handleSendEmail = async () => {
    try {
      const formData = new FormData();
      formData.append("email", selectedCustomer.email);
      formData.append("message", emailMessage);
      formData.append("title", emailTitle);
      if (attachment) {
        formData.append("file", attachment);
      }

      const response = await props.SendCustomerEmailApi(formData);

      setEmailMessage("");
      setEmailTitle("");
      setAttachment(null);
      setSelectedCustomer(null);
      setShowModal(false);

      Swal({
        title: "Success",
        text: "Email Sent Successfully",
        icon: "success",
      });
    } catch (error) {
      Swal({
        title: "Error",
        text: "Failed to send email",
        icon: "error",
      });
    }
  };

  useEffect(() => {
    props.setHeading("Customer List");
  }, []);

  return (
    <>
      <Container fluid>
        <MaterialTable
          tableRef={tableRef}
          title="Customer Details"
          columns={[
            { title: 'Sequence Number', field: 'sequenceNumber', editable: 'never' },
            { title: 'Product Name', field: 'productDetails.productName', editable: 'never' },
            { title: "Customer Name", field: "customerName" },
            { title: "Company Name", field: "companyName" },
            { title: "Owner Name", field: "ownerName" },
            // { title: "Status", field: "status" },
            { title: "Contact Person", field: "contactPerson" },
            // { title: "Designation", field: "designation" },
            { title: "Phone Number", field: "phoneNumberOne" },
            // { title: "Phone Number 2", field: "phoneNumberTwo" },
            // { title: "Office Number", field: "officeNumber" },
            // { title: "City", field: "city" },
            { title: "Address", field: "address" },
            { title: "CR", field: "cr" },
            { title: "Date", field: "date" },
            { title: "Email", field: "email" },
            { title: "Website", field: "website" },
            { title: "Description", field: "description" },
            { title: "Created By", field: "userDetails.userName", editable: 'never' },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = `${baseURL}/CRMCustomer?`;
              url += "size=" + query.pageSize;
              url += "&page=" + query.page;
              url += "&search=" + query.search;
              fetch(url, {
                method: "GET",
                headers: headers,
              }).then((response) => response.json()).then((result) => {
                resolve({
                  data: result.data,
                  page: result.page,
                  totalCount: result.total_results,
                });
              });
            })
          }
          options={{
            actionsColumnIndex: -1,
            exportButton: true,
            exportAllData: true,
            paging: true,
            pageSize: 50,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [50, 100, 150, 200],
            headerStyle: {
              position: "sticky",
              top: 0,
              color: "#00BBBB",
              fontWeight: "550",
              onRowAdd: "none",
            },
          }}
          editable={{
            onRowUpdate: (newData, oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.UpdateCRMCustomerAPi(newData, oldData);
                }, 600);
              }),
            onRowDelete: (oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.DeleteCRMCustomer(oldData._id);
                }, 600);
              }),
          }}
          actions={[
            {
              icon: 'refresh',
              tooltip: 'Refresh Data',
              isFreeAction: true,
              onClick: () => tableRef.current && tableRef.current.onQueryChange(),
            },
            (rowData) => ({
              icon: () => <ForwardToInboxIcon />,
              tooltip: "Send Email",
              onClick: (event, rowData) => handleEmailClick(rowData),
              // onClick: async (event, rowData) => {
              //   try {
              //     const response = await props.SendCustomerEmailApi({ email: rowData.email });
              //     console.log(response, "response")
              //     Swal({
              //       title: "Success",
              //       text: "Email Send Successfully",
              //       icon: "success",
              //     });
              //   } catch (error) {
              //     Swal({
              //       title: "Error",
              //       text: "Invalid Email Format",
              //       icon: "error",
              //     });
              //   }
              // },
            }),
            (rowData) => ({
              icon: () => <CommentIcon />,
              tooltip: "View Comments",
              onClick: (event, rowData) => handleCommentClick(rowData),
            }),
          ]}
        />
      </Container>


      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Send Email</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedCustomer && (
            <>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Recipient Email *</b></Form.Label>
                  <Form.Control
                    type="email"
                    value={selectedCustomer.email}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Email Title *</b></Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Email Title"
                    // value={selectedCustomer.email}
                    onChange={(e) => setEmailTitle(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label><b>Email Message *</b></Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Enter Your Message"
                    // value={emailMessage}
                    onChange={(e) => setEmailMessage(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label><b>Attachment</b></Form.Label>
                  <Form.Control
                    type="file"
                    onChange={(e) => setAttachment(e.target.files[0])}
                  />
                </Form.Group>
              </Col>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSendEmail}>
            Send Email
          </Button>
        </Modal.Footer>
      </Modal>


      <Modal show={showCommentModal} onHide={() => setShowCommentModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Comment Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedCustomer?.comment && selectedCustomer?.comment?.length > 0 ? (
            <ListGroup>
              {selectedCustomer?.comment.map((comment, index) => (
                <ListGroup.Item key={index}>
                  {comment}
                </ListGroup.Item>
              ))}
            </ListGroup>
          ) : (
            <p>No comments available.</p>
          )}
        </Modal.Body>
      </Modal>

    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    DeleteCRMCustomer: (customerId) => dispatch(DeleteCRMCustomer(customerId)),
    SendCustomerEmailApi: (data) => dispatch(SendCustomerEmailApi(data)),
    UpdateCRMCustomerAPi: (newData, oldData) => dispatch(UpdateCRMCustomerAPi(newData, oldData)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  isFetchingCRMCustomer: state.CustomerReducerCRM.isFetchingCRMCustomer,
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewCustomerCRM);
